module.exports = __webpack_public_path__ + "static/media/observer-perspective@2x.2ade3776.png";